import React from "react";
import { Star } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const Testimonials = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="testimonials-section" className="relative bg-[#F7F5F2] py-32 lg:py-44">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="text-center mb-20 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-4 mb-7">
            <span className="w-12 h-px bg-[#B08D57]"></span>
            <span className="overline-bold text-[#B08D57]">{t.testimonials.overline}</span>
            <span className="w-12 h-px bg-[#B08D57]"></span>
          </div>
          <h2 className="font-display-thin text-[#0F0F0F] text-4xl sm:text-5xl lg:text-[58px] tracking-tight leading-[1.1]">
            {t.testimonials.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-[#0F0F0F]/8 border border-[#0F0F0F]/8">
          {t.testimonials.items.map((q, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-white p-10 flex flex-col justify-between min-h-[320px] hover:bg-[#F7F5F2] transition-colors duration-500"
            >
              <div className="flex items-center gap-1 mb-8">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-[#B08D57] text-[#B08D57]" />
                ))}
              </div>
              <blockquote className="font-display-thin text-[#0F0F0F] text-xl sm:text-[22px] leading-[1.45] flex-1">
                "{q.quote}"
              </blockquote>
              <figcaption className="mt-10 pt-6 border-t border-[#0F0F0F]/10">
                <div className="text-[#0F0F0F] text-sm tracking-wide font-semibold">{q.author}</div>
                <div className="overline text-[#B08D57] mt-2">{q.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
